import { DOMAINS } from "../../common-constants";
import { isDevEnvironment, isProdEnvironment } from "../../api-util";

export function getSize() {
  const DESKTOP_MIN = 992;
  const TABLET_MIN = 576;

  return window.innerWidth >= DESKTOP_MIN
    ? "Web"
    : window.innerWidth >= TABLET_MIN
    ? "Tablet"
    : "Mobile";
}

export function getEnv() {
  const host = window.location.hostname;

  if (isDevEnvironment(host)) {
    return "dev";
  } else if (isProdEnvironment(host)) {
    return "prod";
  }
  return "preprod";
}

export function getClickstreamBaseURL() {
  return isProdEnvironment(window.location.hostname)
    ? DOMAINS.ORDER_TAKING.PROD
    : DOMAINS.ORDER_TAKING.PRE_PROD;
}

export function getAuthURL() {
  return isProdEnvironment(window.location.hostname)
    ? `${DOMAINS.ORDER_TAKING.PROD}/auth`
    : `${DOMAINS.ORDER_TAKING.PRE_PROD}/auth`;
}

export function getClientId() {
  const PRE_PROD_CLIENT_ID = "ces-ui_hSuhHpf1RuySBax-MTb0EA";
  const PROD_CLIENT_ID = "ces-ui-prod_8QTA-4DISzm5h3Mp-oKnjg";

  return isProdEnvironment(window.location.hostname)
    ? PROD_CLIENT_ID
    : PRE_PROD_CLIENT_ID;
}



// WEBPACK FOOTER //
// ./client/app/common/clickstream/schemas/clickstream-util.js